import React, { useEffect } from 'react';
import './AuthRedirect.css';

const AuthRedirect = () => {

    useEffect(() => {
        const provider = localStorage.getItem('auth_provider');
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const codeProcessed = localStorage.getItem('codeProcessed');


        if (code) {
            if (provider === 'google' && !codeProcessed) {
                localStorage.setItem('codeProcessed', 'true');
                sendCodeToBackend(code, provider)
                    .then(handleAuthResponse)
                    .catch(handleAuthError);
            } else if (provider === 'facebook') {
                sendCodeToBackend(code, provider)
                    .then(handleAuthResponse)
                    .catch(handleAuthError);
            } else if (provider === 'linkedin') {
                if (!codeProcessed) {
                    localStorage.setItem('codeProcessed', 'true');
                    sendCodeToBackend(code, provider)
                        .then(handleAuthResponse)
                        .catch(handleAuthError);
                }
            }
        }
    }, []);

    const sendCodeToBackend = async (code, provider) => {
        const url = `http://localhost:8000/api/auth/${provider}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code }),
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`Backend authentication failed: ${response.status}`);
        }

        return response.json()
    };

    const handleAuthResponse = (response) => {
        localStorage.removeItem('codeProcessed');
        localStorage.removeItem('auth_provider');
        window.location.href = '/';
    };

    const handleAuthError = (error) => {
        console.error('Error:', error);
        localStorage.removeItem('codeProcessed');
        localStorage.removeItem('auth_provider');
    }

    return (
        <div className='authredirect-font-wrapper'>
            <div className="loading-page">
                <div className="spinner"></div>
                <div className='loading-text'>
                    <p>Please wait, we are processing your login.</p>
                    <p>If this takes too long, <a href="/">click here</a> to return.</p>
                </div>
            </div>
        </div>

    );
};

export default AuthRedirect;
